// Module
var code = `<div class="hoa-dialog__container">
    <div class="hoa-dialog__header hoa-dialog__header--borderNone">
        <h1 tid="termsHeader" id="ngdialog1-aria-labelledby" class="center">{{headerText}}</h1>
    </div>
    <div class="hoa-dialog__main hoa-dialog__main--marginNone">
        <div class="hoa-dialog__HOA-container-scrollableContent">
            <div class="HOA-container__content--legal"
                 tid="termsAll"
                 [innerHTML]="terms | inAppBrowserLink">
            </div>
        </div>
    </div>
    <div class="hoa-dialog__footer hoa-dialog__footer--borderNone" ifOverFlowXClass="hoa-dialog__footer--overflowX">
        <button class="Button Button--outline Button--minWidth130"
                (click)="closeThisDialog('N')"
                tid="termsNoButton" >No
        </button>
        <button class="Button Button--blue Button--minWidth130"
                (click)="closeThisDialog('Y')"
                tid="termsYesButton">Yes
        </button>
    </div>
</div>`;
// Exports
module.exports = code;